export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: '1c4b7039-7791-49ed-a1fa-39c0ff5ab65b'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts